import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Button } from 'react-bootstrap';
import Icofont from 'react-icofont';

class NoDelivery extends React.Component {
  render() {
    const { slug, plz } = this.props.match?.params || {};
    const displayName = (slug || '').split('-')
      .map(w => w.charAt(0).toUpperCase() + w.slice(1))
      .join(' ');

    return (
      <Container className="py-5">
        <Row className="justify-content-center">
          <Col md={8} lg={6} className="text-center">
            <div className="mb-4">
              <Icofont icon="sad" size="5" className="text-danger" />
            </div>
            <h2 className="mb-3">Leider außerhalb des Liefergebiets</h2>
            <p className="mb-2 text-gray">
              {displayName ? `${displayName} liefert leider nicht nach ${plz}.` : `Leider können wir nicht nach ${plz} liefern.`}
            </p>
            <p className="mb-4 text-gray">
              Wählen Sie eine andere Postleitzahl oder ein anderes Restaurant.
            </p>
            <div className="d-flex flex-column flex-md-row justify-content-center" style={{ gap: '10px' }}>
              <Button as={Link} to="/" variant="success" size="lg">
                <Icofont icon="search-restaurant" className="mr-2" />
                Andere PLZ eingeben
              </Button>
              <Button as={Link} to="/listing" variant="outline-secondary" size="lg">
                <Icofont icon="restaurant" className="mr-2" />
                Anderes Restaurant wählen
              </Button>
              <Button as={Link} to="/" variant="link" size="lg">
                Zur Startseite
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default NoDelivery;
